// Change the color of the select box based option selected (empty or not)
let select = document.getElementById("project-type");
select && select.addEventListener("change", function() {
    select.classList.remove('text-lightorange');
});

// Scroll to Response
let formSubmit = document.querySelector('.wpcf7 input[type=submit]');
formSubmit && formSubmit.addEventListener('click', function(event) {
    const container = document.querySelector('#form-container');
    
    setTimeout(function () {
        container.scrollIntoView();
    }, 1000);
});

document.addEventListener( 'wpcf7mailsent', function(event) {
    const websiteUrl = window.location.origin;
    let pageId = false;

    switch(event.detail.contactFormId) {
        case 778:
            pageId = 2815; // Formulaire de contact
            break;
        case 780:
            pageId = 2817; // Prise de rdv
            break;
        case 2779:
            pageId = 2819; // Prise de rdv Strasbourg
            break;
        case 2783:
            pageId = 2821; // Prise de rdv Besançon
            break;
        case 2786:
            pageId = 2823; // Prise de rdv Bretagne
            break;
    }

    if(pageId) {
        const apiUrl = websiteUrl + '/wp-json/wp/v2/pages/' + pageId;

        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                // Récupérer le permalink de la page à partir des données reçues
                const permalink = data.link;
                location = permalink;
            })
            .catch(error => {
                console.error('Erreur lors de la récupération du permalink:', error);
            });
    }

}, false );